module.exports = __webpack_public_path__ + "img/socialhub.24de83d9.png";